<script setup>
import { computed } from 'vue'

const props = defineProps({
  // 24px beside a card's title, 32px beside a guide row.
  size: { type: String, default: 'sm', validator: (size) => ['sm', 'md'].includes(size) },
  // outline: a step still to do · active: the current step's card · page: a step page's heading · filled: a guide row or a link card · completed: a green check-circle, no slot.
  variant: { type: String, default: 'outline', validator: (variant) => ['outline', 'active', 'page', 'filled', 'completed'].includes(variant) },
})

const VARIANTS = {
  outline: 'border border-gray-200 text-gray-500',
  active: 'border border-blue-200 bg-blue-50 text-tint-1',
  page: 'border border-tint-1 bg-blue-50 text-tint-1',
  filled: 'bg-blue-50 text-tint-1',
  completed: 'text-green-500',
}

const isCompleted = computed(() => props.variant === 'completed')
const classes = computed(() => [VARIANTS[props.variant], props.size === 'md' ? 'size-8 text-sm' : 'size-6 text-xs'])
</script>

<template>
  <span
    class="flex items-center justify-center rounded-full font-medium"
    :class="classes"
    :role="isCompleted ? 'img' : undefined"
    :aria-label="isCompleted ? 'Completed' : undefined"
  >
    <Icon v-if="isCompleted" icon="heroicons-solid:check-circle" class="size-full" />
    <slot v-else />
  </span>
</template>
